var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default pt-3"},[(_vm.products.length !== 0)?_c('div',[_c('analytic-chart',{staticClass:"mt-0"})],1):_c('div',[_c('analytic-steps',{attrs:{"stepList":_vm.stepList}}),_c('analytic-empty',{staticClass:"mt-4"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }